import createCache, { type EmotionCache } from '@emotion/cache';

// MUI (Emotion) styles go to the `mui` cascade layer, between Boosted and Tailwind utilities (order in index.html).
// MUI's own StyledEngineProvider enableCssLayer does the same, but its cache has no CSP nonce.
export const createEmotionCache = (nonce: string): EmotionCache => {
  const cache = createCache({
    // After the layer order declaration, which has to be the first style on the page
    insertionPoint:
      document.querySelector<HTMLElement>('meta[name="emotion-insertion-point"]') ?? undefined,
    key: 'css',
    nonce,
  });
  const insert = cache.insert;
  cache.insert = (selector, serialized, sheet, shouldCache) =>
    insert(
      selector,
      /^@layer\s+[^{]*$/.test(serialized.styles)
        ? serialized
        : { ...serialized, styles: `@layer mui {${serialized.styles}}` },
      sheet,
      shouldCache,
    );
  return cache;
};
